import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'GLOBAL_SETTINGS' });



// WEBPACK FOOTER //
// ./src/frontend/modules/settings/global/handlers.js